import { memo, useCallback } from 'react';
import { NodeProps, Handle, Position, NodeResizer, useReactFlow } from '@xyflow/react';

interface ImageNodeProps extends NodeProps {
  data: {
    imageData?: string;
    uuid: string;
    width?: number;
    height?: number;
  };
  selected: boolean;
}

export const ImageNode = memo(({ data, selected, id }: ImageNodeProps) => {
  const { setNodes } = useReactFlow();
  const width = data.width || 200;
  const height = data.height || 150;
  
  const onResize = useCallback((event: any, params: any) => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              width: Math.round(params.width),
              height: Math.round(params.height),
            },
          };
        }
        return node;
      })
    );
  }, [id, setNodes]);
  
  return (
    <>
      {/* Redimensionador com estilo consistente */}
      <NodeResizer 
        minWidth={100} 
        minHeight={75} 
        isVisible={selected}
        onResize={onResize}
        handleStyle={{
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          backgroundColor: '#6366F1',
          border: '2px solid white',
        }}
        lineStyle={{
          borderColor: '#6366F1',
          borderWidth: '2px',
        }}
      />
      
      {/* Container da imagem */}
      <div 
        className={`rounded-lg overflow-hidden shadow-lg ${
          selected ? 'ring-2 ring-primary' : ''
        }`}
        style={{ 
          width: `${width}px`, 
          height: `${height}px`,
          backgroundColor: 'transparent'
        }}
      >
        <img 
          src={data.imageData} 
          alt="Imagem colada"
          className="w-full h-full object-contain"
          draggable={false}
          style={{ backgroundColor: 'transparent' }}
        />
        
        {/* Handles para conexões */}
        <Handle 
          type="target" 
          position={Position.Top} 
          style={{ 
            background: '#6366F1',
            width: '10px',
            height: '10px',
            border: '2px solid white'
          }}
        />
        <Handle 
          type="source" 
          position={Position.Bottom} 
          style={{ 
            background: '#6366F1',
            width: '10px',
            height: '10px',
            border: '2px solid white'
          }}
        />
        <Handle 
          type="target" 
          position={Position.Left} 
          id="left"
          style={{ 
            background: '#6366F1',
            width: '10px',
            height: '10px',
            border: '2px solid white'
          }}
        />
        <Handle 
          type="source" 
          position={Position.Right} 
          id="right"
          style={{ 
            background: '#6366F1',
            width: '10px',
            height: '10px',
            border: '2px solid white'
          }}
        />
      </div>
    </>
  );
});

ImageNode.displayName = 'ImageNode';
